import { Controller } from "@hotwired/stimulus"

// Aperçu immédiat de l'image choisie, avant l'enregistrement.
export default class extends Controller {
  static targets = ["input", "image"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const url = URL.createObjectURL(file)
    this.imageTarget.src = url
    this.imageTarget.classList.remove("hidden")
    this.imageTarget.onload = () => URL.revokeObjectURL(url)
  }
}
